// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33Xbo","name":"styles_name__udcjT","phone":"styles_phone__1rFX_"};